export const normalizeErrorResponse = (errors) => {
  let payload = {};

  for (const key in errors) {
    payload = {
      ...payload,
      [key]: errors[key].join(', '),
    };
  }

  return payload;
};
